'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSmartphone = function MdSmartphone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 31.6v-23.2h-16.8v23.2h16.8z m0-29.9q1.3 0 2.3 1t0.9 2.3v30q0 1.3-0.9 2.3t-2.3 1.1h-16.8q-1.3 0-2.3-1.1t-0.9-2.3v-30q0-1.3 0.9-2.3t2.3-1.1z' })
        )
    );
};

exports.default = MdSmartphone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/smartphone.js
// module id = 3344
// module chunks = 0